export class dropdownlist {
    TimeZone: timezone[];
    vendors: vendors[];
    Zones: ZoneModel[];
    TimeZoneId: number;
    DispatchSetting: DispatchSetting[];
    DispatchHolidaySetting: DispatchSetting[];
    CustomerTypes: CustomerTypes[];
    WorkCategory: WorkCategory[];
}

export class timezone {
    id: number;
    value: string;
}

export class vendors {
    VendorId: number;
    VendorName: string;
    IsActive?: number;
}

export class technician {
    label: string;
    value: any;
}

export class frmtechnician {
    ddlzone: number;
    ddlvendor: number;
    ddlTechnician: string;
    jobFilterValue: number;
    companyid: number;
    scheduledate: string;
    ddlregion: number;
    ddltimezone: number;
    txttechcount: number;
    chkincludeweekend: boolean;
    scheduleenddate: string;
    ddlcustomerType: number = 0;
    month: string;
    ProjectId: any;
    ddlWorkCategory: number;
    MaxRoleGroupId?: number;
    LoginId?: number;
}
export class weekview {
    firstjobtime: string = "";
    TimeLine: string = "";
    details: weekviewlist[] = [];
    error: string;
}

export class weekviewlist {
    techInfo: TechInfo;
    weekdays: weekdays[];
    height: number;
}
export class TechInfo {
    techid: number = 0;
    techname: string = '';
    CompanyId: number = 0;
    IsManager: boolean = false;
    phone1: string = '';
    phone2: string = '';
    email: string = '';
    currentjobid: number = 0;
    vendorname: string = '';
    vphone1: string = '';
    vphone2: string = '';
    PhotoPath: string;
}

export class weekdays {
    scheduledate: Date;
    day: string;
    isCurrentDate: boolean;
    techWorkTime: Techworktime;
    jobdetails: JobDetails[] = [];
    hiddenjobs: JobDetails[] = [];
    offtimejob: offtimejob[] = [];
    timeSlot: Timeslot[] = [];
    jeopardyjobcount: number;
    isHoliday: boolean;
    height: number;
    FirstTechWorkTime: string;
}
export class BoardList {
    techid: number;
    techname: string;
    CompanyId: number;
    IsManager: boolean;
    phone1: string;
    phone2: string;
    email: string;
    fullname: string;
    currentjobid: number;
    scheduledate: string;
    techWorkTime: Techworktime;
    jobdetails: JobDetails[];
    timeSlot: Timeslot[];
    offtimejob: offtimejob[];
    TimeLine: string;
    jeopardyjobcount: number;
    height: number;
    firstjob: string;
    isHoliday: boolean;
}
export class JobDetails {
    WoJobId: number;
    JobNo: number;
    JobStatusId: number;
    ReserveDate?: Date;
    ScheduleDate?: Date;
    ScheduleStartDateTime?: Date;
    ScheduleEndDateTime?: Date;
    PlannedArrivalTime?: Date;
    WorkOrderId: number;
    CustomerName: string;
    IsPmOrder: boolean;
    WoNumber: string;
    IsSLAMet: boolean;
    SLAStartTime: string;
    SLAEndTime: string;
    statusColor: string;
    JobStatus: string;
    Hours: number;
    Minutes: number;
    Starttime: string;
    Endtime: string;
    IsAttention: boolean;
    MsgAttention: string;
    Isjeopardy: boolean;
    startpostion: number;
    width: number;
    top: number;
    startindex?: number;
    endindex?: number;
    jeopardyjobposition?: number;
    CustomerId?: number;
    CustomerTypeId?: number;
    IsCustomerType: boolean = true;
    DBShortCode: string = "";
    WoCategory: string = "";
    ProjectId?: number;
    IsCrossDay: number;
    ScheduleSlot: string;
    ActualScheduleStartDateTime?: Date;
    ActualScheduleEndDateTime?: Date;
}
export class Techworktime {
    Block1StartTime?: Date;
    Block1EndTime?: Date;
    Block2StartTime?: Date;
    Block2EndTime?: Date;
    Block3StartTime?: Date;
    Block3EndTime?: Date;
    Block4StartTime?: Date;
    Block4EndTime?: Date;
    Block5StartTime?: Date;
    Block5EndTime?: Date;
    Offtime1ReasonId?: number;
    Offtime2ReasonId?: number;
    Reason1: string;
    Reason2: string;
    Description1: string;
    Description2: string;
    DisplayName: string;
    LastUpdate?: Date;
    ApprovalNotes: string;
}

export class techaddress {
    AddressLine1: string;
    AddressLine2: string;
    AddressName: string;
    CityName: string;
    ZipCode: string;
    MapLat: string;
    MapLon: string;
    skills: string;
    certification: string;
    GPSUpdate?: Date;
    ScheduleStartDateTime?: Date;
    ScheduleEndDateTime?: Date;
    CustomerTimeZone: string;
    ScheduleSourceId?: number;
    StartTime: string;
    EndTime: string;
    UnitNo: string;
    StateShortName: string;
    CountryName: string;
    phone1: string;
    VendorName: string;
    VendorPhone1: string;
    VendorPhone2: string;
    CustomerName: string;
    ContactFirstName: string;
    ContactLastName: string;
    ContactMName: string;
    ContactPhone2: string;
}

export class techaddressparam {
    companyid: number;
    techid: number;
    jobid: number;
    scheduledate?: string;
}
export class SpErrors {
    PoErrorCode: string;
    PoSeverity: number;
    poErrorMsg: string;
    poSkillAlert?: number;
    PoCertificationAlert?: number;
    PoWorkTypeAlert?: number;
    PoRegionAlert?: number;
    PoTechPreferenceAlert?: number;
}

export class JobDetailpopups {
    WorkTypeTask: WorkTypeTask[];
    Serviceaddress: techaddress;
    skills: string;
    scheduleTime: scheduleTime;
}
export class WorkTypeTask {
    WorkType: string;
    WorkTask: string;
}
export class scheduleTime {
    TravelTime: number;
    ReturnTravelTime: number;
}
export class Direction {
    fromaddress: string;
    toaddress: string;
    fromlat: string;
    fromlon: string;
    tolat: string;
    tolon: string;
}
export class NearTechparam {
    PiWoJobId?: number;
    PiScheduledDate?: string;
    PiLoginId?: number;
    PiZoneId?: number;
    PiRegionId?: number;
    Pinoofrecords?: number;
    PiCompanyId?: number;
    PiTimezoneId?: number;
    PiVendorId?: number;
}
export class nearbytechcian {
    Techname: string;
    distance: string;
    starttime: string;
    availablehrs: string;
    traveltime: string;
    drivetime: string;
    NextDriveTime: string;
    ContactPhone: string;
    techid: string;
    Region: string;
    VendorId: number;
    VendorName: string;
    TechPreferenceId: number;
    IsManager: number;
}

export class neartechworkorder {
    workordernumber: string;
    woJobId: string;
    jobduration: string;
    worktask: string;
    customerprefdate: string;
    preferddate: string;
    CustomerPrefSlot: string;
    isHoliday: boolean;
}

export class nearTechnician {
    header: neartechworkorder;
    details: nearbytechcian[];
    PoIsTechPrefConfigAvailable: number;
}

export class scheduleNeartech {
    PiWoJobId: number;
    piStartTime: string;
    PiTechid: number;
    piloginid: number;
    piIsconfirm: number;
    piTimeZoneid?: number;
    PiCompanyId: number;
    PiComments: string;
    PiVendorId?: number;//added for multi vendor by senthilkumar g
    PiSourceId?: number;
}

export class ScheduleNeartechDetail {
    Severity?: number;
    ErrorMessage: string;
    ErrorCode: string;
    CustomerName: string;
    ServiceAddress: string;
    ContactName: string;
    ContactPhone: string;
    TechnicianName: string;
    TechnicianMobile: string;
    WoJobId?: number;
    StartTime?: Date
    EndTime?: Date
    Status: string;
    JobDuration: string;
    TravelTime: string;
    NextJobTravelTime: string;
    VendorList: mVendors[]
}
export class mVendors {
    VendorId: number;
    VendorName: string;
    IsPrimaryVendor: any;
    CustomerPreferVendor?: number;
}
export class Availablity {
    id: number;
    name: string;
    name1: string;
    color: string;
}

export class MiliteryTime {
    ampm: string;
    standard: string;
}

export class Timeslot {
    id: number;
    index: number;
    TechId: number;
    Timeslot: string;
    color: string;
    scheduledate: string;
}

export class offtimejob {
    Techid: number;
    Starttime: string;
    Endtime: string;
    Reason: string;
    Description: string;
    Createdby: string;
    Modifydate?: Date;
    ApprovalNotes: string;
    startpostion: number;
    width: number;
}
export class ColorCode {
    DispatchWorkTime1: string;
    DispatchWorkTime2: string;
    DispatchOverTime1: string;
    DispatchOverTime2: string;
    DispatchOffTime1: string;
    DispatchOffTime2: string;
}
export class UnAssignJobsdata {
    UnAssignJobs: UnAssignJobs[];
    TotalRecord?: number;
}
export class UnAssignJobs {
    JobStatusId: number;
    WoJobId: number;
    WorkOrderId?: number;
    CustomerId?: number;
    CustomerStatusId?: number;
    CustomerName: string;
    WoNumber: string;
    Hours: string;
    Minutes: string;
    Zone: string;
    Region: string;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    ZipCode: string;
    JobStatus: string;
    Phone1: string;
    color: string;
    JobNo: string;
    DisplayName: string;
    IsSLAMet?: boolean;
    ApptPrefTime?: Date;
    IsUnAssignPanel?: boolean;
    DBShortCode: string = "";
    WoCategory: string = "";
    SlotStartTime: string = "";
    CountryName: string;
    ContactName: string;
    ProjectId: number;
    SLAStartTime: string;
    SLAEndTime: string;
    SlotName: string;
}
export class ZoneModel {
    ZoneId: number;
    Zone: string;
    Description: string;
    IsActive: string;
}
export class Region {
    Regionid: number;
    Region: string;
}

export class unassignpanelparam {
    companyid: number;
    vendorId: number;
    ProjectId: number;
    regionid: string;
    customertypeid: number[] = [];
    categoryId?: number;
    isFilter: boolean;
    filterfield: string;
    filtervalue: string;
    sorting: string;
    timezone?: number;
    startrecord?: number;
    endrecord?: number;
    maxRoleGroupId?: number;
    LoginId?: number;
}

export class unassignpanelfilter {
    ddlfilter: string;
    filtertxt: string;
    ddlsort: string;
}
export class confirmationpopup {
    mtype: number;
    mheader: any;
    mcontent: any;
    mfooter: boolean;
}

export class DispatchSetting {
    SettingId: number;
    Setting: string;
    SettingValue?: number;
}

export class GetObjParam {
    CompanyId: number;
    ZoneId?: number[];
    RegionId?: number[];
    VendorId?: number[];
    LoginId?: number;
    ProjectId?: number;
    MaxRoleGroupId?: number;
}
export class CustomerTypes {
    customerTypeId: number;
    customerType: string;
}
export class SmsLog {
    // companyid: number;
    // smscontent: string;
    // tonumber: string;
    // workorderid: number;
    // wojobid: number;
    // jobstatusid: number;
    // loginid: number;
    // WoAppointmentId: number;
    companyid: number;
    smscontent: string;
    tonumber: string;
    workorderid: number;
    wojobid: number;
    jobstatusid: number;
    loginid: number;
    WoAppointmentId: number;
    FileName: string;
    Path: string;
    FilePath: string;
}
export class MonthView {
    MonthViewList: MonthViewList[] = [];
    Error: string;
}
export class MonthViewList {
    techInfo: TechInfo;
    monthdays: monthdays[] = [];
}
export class monthdays {
    techId: number;
    WorkDate: Date
    Workduration?: number;
    CompletedJobDuration?: number;
    Scheduledduration?: number;
    companyid?: number;
    weekend: boolean;
    holiday: boolean;
    date: number;
    color: string;

    // PT-1645 Dispatcher Board-month View: System fails to display separate color code for weekend and for public holidays in Header
    // Added/ Modified by Anvardeen Batcha B
    headercolor: string;
}
export class monthcaldays {
    techId: number;
    WorkDate: Date
    Workduration?: number;
    CompletedJobDuration?: number;
    Scheduledduration?: number;
    companyid?: number;
    weekend: boolean;
    holiday: boolean;
    date: number;
}
export class MonthViewDays {
    Techid: number;
    ScheduleDate: Date;
    Jobs: MonthJobsDetail[];
    //internal
    color: string = "efefef";
    panel: string = "available";
    Holiday: boolean;
    Weekend: boolean;
}
export class MonthJobsDetail {
    CustomerName: string;
    CompanyId: number;
    JobNo: number;
    JobStatus: string;
    JobStatusId: number;
    ScheduleDate: Date;
    WoJobId: number;
    WorkOrderId: number;
    StatusColor: string;
    CustomerId: number;
    WoNumber: string;
    TechId: number;
    Hours: string;
    Minutes: string;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    ZipCode: string;
    Phone1: string;
    ApptPrefTime?: Date;
    SlotStartTime: string;
    CountryName: string;
    ContactName: string;

    ScheduleStartDateTime: string;
    ScheduleEndDateTime: string;


}
export class CompanyWeekends {
    IsSundayWeekEnd: number;
    IsMondayWeekEnd: number;
    IsTuesdayWeekEnd: number;
    IsWednesdayWeekEnd: number;
    IsThursdayWeekEnd: number;
    IsFridayWeekEnd: number;
    IsSaturdayWeekEnd: number;
}
export class Projects {
    ProjectId: number;
    ProjectName: string;
}
export class VendorList {
    VendorId: number;
    VendorName: string;
    IsPrimaryVendorId: number;
    IsActive?: number;
}
export class Config {
    ConfigDtlId: number;
    Description: string;
}
export class SystemSetting {
    SettingCompId: number;
    CompanyId: number;
    SettingId: number;
    Setting: string;
    SettingValue: string;
    SettingGroupId: number;
    IsUiSetting: number;
    SettingUnit: string;
    OrderId: number;
    StartTime: string;
    EndTime: string;
    IsActive: number;
    LastChangedBy: number;
}
export class WorkCategory {
    WoCategoryId: number;
    WoCategory: string;
}
export class JobSlaDetails {
    WoJobId: number;
    PriorityName: string;
    ShowSlaTimer: number;
    IsSlaEnabled: number;
    SLAStartTime: string;
    SLAEndTime: string;
    ActualSLAEndTime: string;
    Duration: number;
    IsSLAMet: number;
    SLATypeId: number;
}
export class Smslog {
    SmsContent: string;
    tonumber: number;
    WoJobId: number;
    WorkOrderId: number;
    DisplayName: string;
    SourceSystem: string;
    LogType: number;
    CreatedDate: string;

}

export class printnotesparam {
    CustomerId: number;
    TechTimeZoneId: number;
    WoId: number;
    JobId: number;
    CustomerName: string;
    WoNumber: string;
}

export class MultiSelectitem {
    label: string;
    value: any;
}
export class RequestMonthDayViewData {
    Companyid: number;
    Techid: number;
    Month: string;
    CustomerTypeId: number[] = [];
    ProjectId: number[] = [];
    CategoryId: number;
}

export class TechnicianPopupDetails {
    TechInfo: TechInfo;
    skills: string = '';
    certification: string = '';
}


// @piIsconfirm  -- 0 schedule parameter verification, 1 – Confirm popup, 2 – Save Appointment